import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import { TextBold } from 'UiKit/typography';
import { ArrowLeftIcon } from 'Asset/icon';

import { useScheduleGenerateState } from 'View/schedule-generate/state';
import useCloseModalRestriction from 'View/schedule-generate/hooks/useCloseModalRestriction';

import styles from './styles.module.css';

const Head = () => {
  const { t } = useTranslation('schedule-generate');
  const { viewState, updateState } = useScheduleGenerateState();
  const onCloseRestriction = useCloseModalRestriction();

  const handleBack = () => {
    if (viewState === 'form') onCloseRestriction();
    else updateState({ viewState: 'form' });
  };

  return (
    <Box className={styles['head__container']}>
      <Flex justifyContent={'start'} height={'42px'}>
        <ArrowLeftIcon size="18px" className={styles['head__icon--arrow-left']} onClick={handleBack} color="var(--color-primary70)" data-testid="back-button-generate-schedule"/>
      </Flex>
      <Condition statement={viewState !== 'generate-result'}>
        <TextBold className={styles['head__text--title']}>{t('title')}</TextBold>
      </Condition>
    </Box>
  );
};

export default Head;
